import {createStrokeSVG} from './TEMPLATE'

// lucide: app-window
export const Window_Stroke2_Corner2_Rounded = createStrokeSVG({
  paths: [
    'M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-16a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2z',
    'M10 4v4',
    'M2 8h20',
    'M6 4v4',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
